import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import titleCaseString from "../../utils/titleCaseUtils";
import useUpdate from "../../hooks/useUpdate";
import DateFormatter from "../../utils/dateFormatterUtils";
import Swal from "sweetalert2";
import LoadingAnimation from "../../components/Loading";


import ImageGallery from 'react-image-gallery';
// CSS
import '../../styles/pages/page-profile.css'
import '../../styles/image-gallery.css';
import { height, width } from "@mui/system";
import {isValidFile, getFilePath} from '../../utils/imageValidatorUtils'

 


const TransactedDetails = ({ selectedItem,handleDelete }) => {


    const { updateData, isLoading, errorMessage, successMessage } = useUpdate();
    const transaction_status = selectedItem.transaction_status
    const transaction_id     = selectedItem.transaction_id

    
    const defaultImagePath = '/iusevolutione/assets/img/no-attachment.svg';

    // Check if the selected item files are valid
    const attachmentIsValid  = isValidFile(selectedItem.attachment_id_file);
    const signatureIsValid   = isValidFile(selectedItem.signature_file);
    const certificateIsValid = isValidFile(selectedItem.certificate_of_registration_file);


    console.log(attachmentIsValid);
    console.log(selectedItem.signature_file);
    console.log(selectedItem.certificate_of_registration_file);

    const images = [
        {
          original     : getFilePath(selectedItem.attachment_id_file, defaultImagePath),
          thumbnail    : getFilePath(selectedItem.attachment_id_file, defaultImagePath),
          originalAlt  : attachmentIsValid ? `Attached ${selectedItem.attachment_id_type}`: 'No Attached ID',
          originalTitle: attachmentIsValid ? `Attached ${selectedItem.attachment_id_type}`: 'No Attached ID',
          description  : attachmentIsValid ? `Attached ${selectedItem.attachment_id_type}`: 'No Attached ID',
        },
        {
          original     : getFilePath(selectedItem.signature_file, defaultImagePath),
          thumbnail    : getFilePath(selectedItem.signature_file, defaultImagePath),
          originalAlt  : signatureIsValid ? 'Signature'                            : 'No Attached Signature',
          originalTitle: signatureIsValid ? 'Signature'                            : 'No Attached Signature',
          description  : signatureIsValid ? 'Signature'                            : 'No Attached Signature',
        },
        {
          original     : getFilePath(selectedItem.certificate_of_registration_file, defaultImagePath),
          thumbnail    : getFilePath(selectedItem.certificate_of_registration_file, defaultImagePath),
          originalAlt  : certificateIsValid ? 'Certificate of Registration'                          : 'No Registration File',
          originalTitle: certificateIsValid ? 'Certificate of Registration'                          : 'No Registration File',
          description  : certificateIsValid ? 'Certificate of Registration'                          : 'No Registration File',
        }
      ];

    const handleSubmit = async (status) => {
        let formField = new FormData();

        formField.append("transaction_status", status);
    
        const result = await Swal.fire({
          
            title            : `Do you want ${status=="DENIED"?"deny" : "accept"} application?`,
            icon             : 'question',
            showCancelButton : true,
            confirmButtonText: 'Yes,proceed!',
            cancelButtonText : 'No, cancel',
            customClass: {
                container: 'swal2-container',
            },
            confirmButtonColor: '#03c3ec',
            cancelButtonColor: '#ff3e1d',


        });
    
        if (result.isConfirmed) {
            try {


            await updateData(`${process.env.REACT_APP_API_URL}/transactions/${transaction_id}/`, formField, () => {});
            handleDelete(selectedItem)
                

            } catch (error) {
                console.error("Error updating data:", error);
            }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            console.log('Submission cancelled.');
        }
    }

 
     

    return (
        <>
            {selectedItem &&

                <>
                    {isLoading && <LoadingAnimation />}
                    {errorMessage && <div className="alert alert-danger">{String(errorMessage)}</div>}
                    {successMessage && <div className="success">{successMessage}</div>}


                    <div className="container-xxl flex-grow-1 p-0 m-0">
                        <div className="col-12">
                            <div className="card mb-4">
                                <div className="user-profile-header-banner">
                                    <img src="/iusevolutione/assets/img/pages/profile-banner.png" alt="Banner image" className="rounded-top" />
                                </div>
                                <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-4">
                                    <div className="flex-shrink-0 mt-n2 mx-sm-0 mx-auto">
                                        <img src={selectedItem.user_transacted?.verification_profile_photo ?? "/iusevolutione/assets/img/illustrations/prize-light.png" } alt="user image" className="d-block h-auto ms-0 ms-sm-4 rounded user-profile-img" />
                                    </div>
                                    <div className="flex-grow-1 mt-3 mt-sm-5">
                                        <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                                            <div className="user-profile-info">
                                                <h4>{selectedItem.first_name?.toUpperCase() + " " + selectedItem.last_name?.toUpperCase()}</h4>
                                                <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                                                    <li className="list-inline-item fw-medium"><i className="bx bx-envelope" /> {selectedItem.user_transacted.email}</li>
                                                    <li className="list-inline-item fw-medium"><i className="bx bx-map" />{selectedItem.barangay}</li>
                                                </ul>
                                            </div>

                                            {transaction_status!=="FOR OATH" && 
                                               <button type="button" onClick={() => handleSubmit("FOR OATH")} className="btn btn-success text-nowrap">
                                               Accept Applications
                                           </button>
                                            }
                                         

                                            <button type="button" onClick={() => handleSubmit("DENIED")} className="btn btn-danger text-nowrap">
                                                Deny Application
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-6">
                                {/* User Information */}
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <small className="text-muted text-uppercase">User Information</small>
                                        <ul className="list-unstyled mb-4 mt-3"> 
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-user" /><span className="fw-medium mx-2">Fullname:</span> <span>{titleCaseString(selectedItem.first_name?.toUpperCase() + " " + selectedItem.last_name?.toUpperCase())}</span>
                                            </li>

                                            
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-male-female" /><span className="fw-medium mx-2">Gender:</span> <span>{titleCaseString(selectedItem.gender)}</span>
                                            </li>

                                            
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-calendar" /><span className="fw-medium mx-2">Birthdate:</span> <span>{DateFormatter(selectedItem.birth_date, 'MM DD, YYYY')}</span>
                                            </li>

                                            
                                 
                                            
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-map-pin" /><span className="fw-medium mx-2">Location:</span> <span>{(`${titleCaseString(selectedItem.country !== selectedItem.country ? selectedItem.country : "" )} ${selectedItem.province} ${titleCaseString(selectedItem.city)} ${titleCaseString(selectedItem.barangay)}`)}</span>
                                            </li>

                       


                                        </ul>
                                        <small className="text-muted text-uppercase">Contacts</small>
                                        <ul className="list-unstyled mt-3">
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-phone" /><span className="fw-medium mx-2">Contact:</span>
                                                <span>{selectedItem.contact_number}</span>
                                            </li>
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-envelope" /><span className="fw-medium mx-2">Email:</span>
                                                <span>{selectedItem.user_transacted.email}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>


                            <div className="card">
                                <div className="card-body">

                                    <small className="text-muted text-uppercase">ID AND Attachments</small>

                                   
                                  

                                    <ul className="list-unstyled mb-4 mt-3">
                                   
                                        <li className="d-flex align-items-center mb-3">
                                            <i class='bx bx-id-card' /><span className="fw-medium mx-2">ID:</span> <span>{selectedItem.attachment_id_type}</span>
                                        </li>

                                        <li className="d-flex align-items-center mb-3">
                                            <i class='bx bx-credit-card-front' /><span className="fw-medium mx-2">ID Number:</span> <span>{selectedItem.attachment_id_number}</span>
                                        </li>

                                        <li className="d-flex align-items-center mb-3" style={{minWidth:400,minHeight:375}}>
                                            <div className="row d-flex justify-content-center">
                                                <div className="col-md-12 w-100 h-100">
                                                    <ImageGallery showPlayButton={false} style={{ width: 100,height:100 }} items={images} showThumbnails={false} />
                                                </div>
                                            </div>
                                            
                                        </li>
                                    </ul>


                                    


                                </div>
                            </div>



                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6">
                                {/* Activity Timeline */}
                                <div className="card card-action">
                                    <div className="card-header align-items-center pb-2">
                                        <h5 className="card-action-title mb-0"><i className="bx bx-info-circle me-2" />Transaction Information</h5>
                                  
                                    </div>

                                    <div className="card-body">


                                    <ul className="list-unstyled mb-4 mt-3">
                                        <li className="d-flex align-items-center mb-3">
                                            <i className="bx bx-check" /><span className="fw-medium mx-2">Transaction ID :</span><span>{selectedItem.transaction_id} ({titleCaseString(selectedItem.transaction_status)})</span>
                                        </li>

                                        <li className="d-flex align-items-center mb-3">
                                            <i className="bx bx-calendar-alt" /> <span className="fw-medium mx-2">Date Created :</span> {DateFormatter(selectedItem.date_created, 'MM DD, YYYY')}
                                        </li>

                                        <li className="d-flex align-items-center mb-3">
                                            <i className="bx bx-flag" /><span className="fw-medium mx-2">Inside the Philippines :</span> <span className={`${selectedItem.is_inside_philippines?.toLowerCase() == "yes" ? "text-success" : "text-danger"}`}>{titleCaseString(selectedItem.is_inside_philippines)}</span>
                                        </li>


                                        <li className="d-flex align-items-center mb-3">
                                            <i className="bx bxs-file-doc" /><span className="fw-medium mx-2">Document Type :</span> <span>{titleCaseString(selectedItem.document_name)}</span>
                                        </li>

                                        <li className="d-flex align-items-center mb-3">
                                            <i class='bx bx-dollar-circle' /><span className="fw-medium mx-2">Price :</span> <span>{selectedItem.document_price} - {selectedItem.transaction_payment_status} </span><span className="badge bg-label-success">Ref#: {selectedItem.reference_number}</span>
                                        </li>
                                    </ul>

 
                                       

                                        <small className="text-muted text-uppercase">Vehicle Information</small>
                                        
                                        <ul className="list-unstyled mb-4 mt-3">
                                           <li className="d-flex align-items-center mb-3">
                                                <i className="bx bxs-car-mechanic" /><span className="fw-medium mx-2">Category:</span> <span>{titleCaseString(selectedItem.vehicle_category)}</span>
                                            </li>
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-car" /><span className="fw-medium mx-2">Type:</span> <span>{titleCaseString(selectedItem.vehicle_type)}</span>
                                            </li>
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-car" /><span className="fw-medium mx-2">Vehicle:</span> <span>{selectedItem.vehicle}</span>
                                            </li>
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-id-card" /><span className="fw-medium mx-2">License:</span> <span>{selectedItem.vehicle_license_category}</span>
                                            </li>

                                        </ul>

                                        <small className="text-muted text-uppercase">Miscellaneous Information</small>
                                            
                                    <ul className="list-unstyled mb-4 mt-3">
                                        <li className="d-flex align-items-center mb-3">

                                            <span class="badge badge-center rounded-pill bg-label-danger"><i className="bx bx-question-mark" /></span>
                                            <span className="fw-medium mx-2">Will the notarized document be used in the Philippines or abroad ?</span> <span className="text-success fw-bolder">{selectedItem.question_1}</span>
                                        </li>

                                        <li className="d-flex align-items-center mb-3">
                                            <span class="badge badge-center rounded-pill bg-label-danger"><i className="bx bx-question-mark" />
                                            </span><span className="fw-medium mx-2">Is your document signed by all signatories by hand (wet-signed) ?</span> <span className="text-success fw-bolder">{selectedItem.question_2}</span>
                                        </li>

                                        <li className="d-flex align-items-center mb-3">
                                            <span class="badge badge-center rounded-pill bg-label-danger"><i className="bx bx-question-mark" />
                                            </span><span className="fw-medium mx-2">Were the signatories in the Philippines when they signed the document ?</span> <span className="text-success fw-bolder">{selectedItem.question_3}</span>
                                        </li>

                                        <li className="d-flex align-items-center mb-3">
                                            <span class="badge badge-center rounded-pill bg-label-danger"><i className="bx bx-question-mark" /></span>
                                            <span className="fw-medium mx-2">Are the signatories currently in the Philippines ?</span> <span className="text-success fw-bolder">{selectedItem.question_4}</span>
                                        </li>

                                    </ul>


                                    </div>


                                </div>

                            </div>

                     
                        </div>

                    </div>
                </>
            }
        </>
    );
}

export default TransactedDetails;